<app-theme>
  <div class="container">
    <a class="logo" appLogo></a>
    <h1>Loading Credit SAGE...</h1>
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>
</app-theme>
